import "./mobileServices.css";
import {useEffect, useState} from "react";
import { Drawer, Form, Select, Input, DatePicker, Popover, Divider, Checkbox, Button, Tag, Empty, Typography, Space, Alert } from "antd";
import Spinner from "@src/components/spinner";
import { Clock, Check, X, Search, FileText, Paperclip, User, Users, MapPin, Calendar, Bell } from "lucide-react";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GetEmployeeRecord } from "@src/util/query/employee.query";
import { getSitesQuery } from "@src/util/query/site.query";
import { getAgencies } from "@src/util/query/agency.query";
import { useDebounce } from "@src/components/debounceSearch/debounceSearch";
import { getSiteTaskQuery } from "../../util/query/siteTask.query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const { Text, Title } = Typography;

export const MobileServicesTaskFormDrawer = ({visible, onClose})=>{

    const {Option} = Select;
    
    const [reminder, setReminder] = useState();
    const [dueDate, setDueDate] = useState();
    const [dueTime, setDueTime] = useState();
    const [notes, setNote] = useState();
    const [selectedTasks, setSelectedTasks] = useState([]);

    const [activeAssignedModule, setActiveAssignedModule] = useState("employee");
    const [search, setSearch] = useState("");
    const debounceSearchValue = useDebounce(search,500);

    const [getEmployee, {data: employeeData, loading: employeeDataLoading}] = useLazyQuery(GetEmployeeRecord,{
        fetchPolicy: 'cache-and-network'
    });

    const [getAgency, {data: agencyData, loading: agencyLoading}] = useLazyQuery(getAgencies,{fetchPolicy: 'cache-and-network'});
    
    useEffect(()=>{
        if(activeAssignedModule=="supplier" && debounceSearchValue?.length>0){
            getAgency({
                variables: {
                    input: {
                        filters: null,
                        pageSize: 20,
                        page: 1,
                        search: debounceSearchValue
                    }
                }
            });
        }else if(activeAssignedModule=="employee" && debounceSearchValue?.length>2){
            getEmployee({
                variables: {
                    input: {
                        filters:  null,
                        pageSize: 20,
                        page: 1,
                        search: debounceSearchValue
                    }
                }
            })
        }
    },[activeAssignedModule, debounceSearchValue]);

    const [assignedEmployee, setAssignedEmployee] = useState([]);
    const [assignedSupplier, setAssignedSupplier] = useState([]);

    const totalAssociation = Number(assignedSupplier?.length)+Number(assignedEmployee?.length);

    // get site list
    const [getSites, {data: siteData, loading: siteLoading}] = useLazyQuery(getSitesQuery,{fetchPolicy: 'cache-and-network'});

    const [sites, setSites] = useState([]);
    useEffect(()=>{
        if(siteData?.sites?.sites){
            setSites([...siteData?.sites?.sites]);
        }else{
            setSites([]);
        }
    },[siteData]);

    const [siteSearch, setSiteSearch] = useState("");
    const debounceSiteSearchValue = useDebounce(siteSearch,500);

    useEffect(()=>{
        if(debounceSiteSearchValue){
            getSites({
                variables: {
                    input: {
                        filters: null,
                        pageSize: 20,
                        page: 1,
                        search: debounceSiteSearchValue
                    }
                }
            })
        }
    },[debounceSiteSearchValue]);

    const [selectedSites, setSelectedSites] = useState([]);

    const handelSiteSelect = async(site)=>{
        const isExist = selectedSites?.find((sSite)=>sSite?._id==site?._id);
        if(isExist){
            setSiteSearch("");
        }else{
            setSelectedSites([...selectedSites, site]); 
            setSiteSearch("");
        }
        await getSiteTask({
            variables:{
                siteId: site?._id
            }
        });
    };

    const handelSiteUnSelect = (site)=>{
        setSelectedSites(
            selectedSites?.filter((sSite)=>{
                if(sSite?._id!==site?._id){
                    return sSite;
                }
            })
        );
    };

    const [getSiteTask, {data:siteTask, loading: siteTaskLoading}] = useLazyQuery(getSiteTaskQuery);

    const handleTaskSelection = (taskId, checked) => {
        if (checked) {
            setSelectedTasks([...selectedTasks, taskId]);
        } else {
            setSelectedTasks(selectedTasks.filter(id => id !== taskId));
        }
    };

    const handleSelectAllTasks = (checked) => {
        if (checked) {
            const allTaskIds = siteTask?.getSiteTask?.response?.map(task => task._id) || [];
            setSelectedTasks(allTaskIds);
        } else {
            setSelectedTasks([]);
        }
    };

    const isFormValid = () => {
        return totalAssociation > 0 && (selectedSites.length > 0 || selectedTasks.length > 0);
    };

    const [days, setDays] = useState({all: false, mon:false, tue:false, wed:false, thu:false, fri:false, sat:false, sun:false});
    
    const handelAllDays = (target)=>{
        if(target.value=="all" && target.checked){
            setDays({
                all: true,
                mon: true, tue: true, wed: true, thu:true, fri: true, sat: true, sun: true
            });
        }else{
            setDays({all: false, mon:false, tue:false, wed:false, thu:false, fri:false, sat:false, sun:false})
        }
    }

    const handelSubmit = (createAnother) => {
        // Your submit logic here
        console.log("Submit", { createAnother });
    };

    const getAssignmentSummary = () => {
        if (totalAssociation === 0) return "No assignment";
        const type = assignedEmployee?.length > 0 ? "Employee" : "Supplier";
        const name = assignedEmployee?.length > 0 
            ? employeeData?.getEmployee?.response?.find(emp => emp._id === assignedEmployee[0])?.firstname + " " + employeeData?.getEmployee?.response?.find(emp => emp._id === assignedEmployee[0])?.lastname
            : agencyData?.agencies?.agencies?.find(sup => sup._id === assignedSupplier[0])?.suppliername;
        return name || `${totalAssociation} ${type}${totalAssociation > 1 ? 's' : ''}`;
    };


    return (
        <div>
            <Drawer
                title={"Assign Task"}
                placement="right"
                closable={true}
                onClose={onClose}
                closeIcon={<FontAwesomeIcon icon={faClose} style={{marginRight:'10px'}} className='close-icon'/>}
                visible={visible}
                width={600}                
                maskClosable={false}
                mask={true}
                footer={
                    <div className='drawer-footer'>
                        <button 
                            className={isFormValid()? "drawer-filled-btn" : "disabled-btn drawer-filled-btn"}
                            onClick={() => handelSubmit(false)}
                            disabled={!isFormValid()}

                        >
                            Assign Task
                        </button>
                        <button 
                            className={isFormValid()? "drawer-filled-btn" : "disabled-btn drawer-outlined-btn"}
                            onClick={() => handelSubmit(true)}
                            disabled={!isFormValid()}
                        >
                            Create and assign another
                        </button>
                        
                        <button onClick={onClose} className='drawer-outlined-btn'>Cancel</button>

                    </div>
                }
            >
                <Form layout="vertical" style={{ padding: '8px 0' }}>
                    
                    {/* Assignment Section */}
                    <div>
                        <Form.Item  className="suffix-input">
                            <label>
                                Assigned to
                            </label>
                            <Popover
                                placement="bottomLeft"
                                trigger="click"
                                overlayClassName="associationCustomPopover"
                                overlayStyle={{ width: '400px', padding:'12px'  }}
                                content={
                                    <div style={{ width: '100%' }}>
                                        <div style={{ marginBottom: '16px' }}>
                                            <Text strong>Select Assignment Type</Text>
                                        </div>
                                        
                                        <div style={{ display: 'flex', marginBottom: '16px', borderRadius: '6px', overflow: 'hidden', border: '1px solid #d9d9d9' }}>
                                            <Button
                                                type={activeAssignedModule === "employee" ? "primary" : "default"}
                                                style={{ flex: 1, borderRadius: 0 }}
                                                onClick={() => setActiveAssignedModule("employee")}
                                                icon={<User size={16} />}
                                            >
                                                Employee
                                            </Button>
                                            <Button
                                                type={activeAssignedModule === "supplier" ? "primary" : "default"}
                                                style={{ flex: 1, borderRadius: 0 }}
                                                onClick={() => setActiveAssignedModule("supplier")}
                                                icon={<Users size={16} />}
                                            >
                                                Supplier
                                            </Button>
                                        </div>

                                        <Input
                                            placeholder={`Search ${activeAssignedModule}...`}
                                            prefix={<Search size={16} />}
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            style={{ marginBottom: '12px' }}
                                            allowClear

                                            className="generic-input-control"
                                        />

                                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                            {(employeeDataLoading || agencyLoading) ? (
                                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                                    <Spinner />
                                                </div>
                                            ) : (
                                                <>
                                                    {activeAssignedModule === "employee" && employeeData?.getEmployee?.response?.length > 0 && 
                                                        employeeData.getEmployee.response.map((employee) => (
                                                            <div
                                                                key={employee._id}
                                                                style={{
                                                                    padding: '12px',
                                                                    cursor: 'pointer',
                                                                    borderRadius: '6px',
                                                                    marginBottom: '4px',
                                                                    backgroundColor: assignedEmployee.includes(employee._id) ? '#e6f7ff' : 'transparent',
                                                                    border: assignedEmployee.includes(employee._id) ? '1px solid #1890ff' : '1px solid transparent'
                                                                }}
                                                                onClick={() => {
                                                                    setAssignedEmployee([employee._id]);
                                                                    setAssignedSupplier([]);
                                                                    setSearch("");
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color:'black' }}>
                                                                    {assignedEmployee.includes(employee._id) && <Check size={16} color="#1890ff" />}
                                                                    <User size={16} />
                                                                    <span>{employee.firstname} {employee.lastname}</span>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                    
                                                    {activeAssignedModule === "supplier" && agencyData?.agencies?.agencies?.length > 0 &&
                                                        agencyData.agencies.agencies.map((supplier) => (
                                                            <div
                                                                key={supplier._id}
                                                                style={{
                                                                    padding: '12px',
                                                                    cursor: 'pointer',
                                                                    borderRadius: '6px',
                                                                    marginBottom: '4px',
                                                                    backgroundColor: assignedSupplier.includes(supplier._id) ? '#e6f7ff' : 'transparent',
                                                                    border: assignedSupplier.includes(supplier._id) ? '1px solid #1890ff' : '1px solid transparent'
                                                                }}
                                                                onClick={() => {
                                                                    setAssignedSupplier([supplier._id]);
                                                                    setAssignedEmployee([]);
                                                                    setSearch("");
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color:'black' }}>
                                                                    {assignedSupplier.includes(supplier._id) && <Check size={16} color="#1890ff" />}
                                                                    <Users size={16} />
                                                                    <span>{supplier.suppliername}</span>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                    
                                                    {((activeAssignedModule === "employee" && search && (!employeeData?.getEmployee?.response?.length)) ||
                                                      (activeAssignedModule === "supplier" && search && (!agencyData?.agencies?.agencies?.length))) && (
                                                        <Empty 
                                                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                            description="No results found"
                                                            style={{ margin: '20px 0' }}
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                }
                            >
                                <Input
                                    readOnly
                                    style={{ cursor: 'pointer' }}
                                    value={getAssignmentSummary()}
                                    suffix={<Search size={16} />}
                                    placeholder="Click to assign"
                                    className="generic-input-control"
                                />
                            </Popover>
                            
                            {totalAssociation > 0 && (
                                <div style={{ marginTop: '8px' }}>
                                    <Tag color="blue" icon={assignedEmployee.length > 0 ? <User size={12} /> : <Users size={12} />}>
                                       &nbsp; {getAssignmentSummary()}
                                    </Tag>
                                </div>
                            )}
                        </Form.Item>
                    </div>

                    {/* Site Task Assignment */}
                    <div >
                        <Form.Item className="suffix-input">
                            <label>Assign site tasks</label>
                            <Popover
                                placement="bottomLeft"
                                trigger="click"
                                overlayClassName='associationCustomPopover'
                                overlayStyle={{ width: '700px', padding:'12px' }}
                                content={
                                    <div style={{ display: 'flex', height: '400px' }}>
                                        {/* Sites Selection */}
                                        <div style={{ width: '300px', borderRight: '1px solid #f0f0f0', paddingRight: '16px' }}>
                                            <div style={{ marginBottom: '16px' }}>
                                                <Text strong>Select Sites</Text>
                                            </div>
                                            
                                            <Input
                                                placeholder="Search sites..."
                                                prefix={<Search size={16} />}
                                                value={siteSearch}
                                                onChange={(e) => setSiteSearch(e.target.value)}
                                                style={{ marginBottom: '12px' }}
                                                allowClear
                                                className="generic-input-control"
                                            />

                                            <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
                                                {selectedSites.map((site) => (
                                                    <div
                                                        key={site._id}
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center'
                                                        }}
                                                        className="popoverdataitem popoverdataitem-active"
                                                    >
                                                        <div style={{ display: 'flex', color:'black', alignItems: 'center', gap: '8px' }} onClick={()=>handelSiteSelect(site)}>
                                                            <MapPin size={16} />
                                                            <span>{site.sitename}</span>
                                                        </div>
                                                        <X 
                                                            size={16} 
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => handelSiteUnSelect(site)}
                                                        />
                                                    </div>
                                                ))}

                                                {sites?.filter(site => !selectedSites?.find(sSite => sSite._id === site._id))
                                                    .map((site) => (
                                                    <div
                                                        key={site._id}
                                                        style={{
                                                            padding: '8px 12px',
                                                            marginBottom: '4px',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => handelSiteSelect(site)}
                                                        className="popoverdataitem"
                                                    >
                                                        <div style={{ display: 'flex', color:'black', alignItems: 'center', gap: '8px' }}>
                                                            <MapPin size={16} />
                                                            <span>{site.sitename}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Tasks Selection */}
                                        <div style={{ flex: 1, paddingLeft: '16px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                                <Text strong>Available Tasks</Text>
                                                {siteTask?.getSiteTask?.response?.length > 0 && (
                                                    <Checkbox
                                                        checked={selectedTasks.length === siteTask?.getSiteTask?.response?.length}
                                                        indeterminate={selectedTasks.length > 0 && selectedTasks.length < siteTask?.getSiteTask?.response?.length}
                                                        onChange={(e) => handleSelectAllTasks(e.target.checked)}
                                                    >
                                                        Select all
                                                    </Checkbox>
                                                )}
                                            </div>

                                            <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
                                                {siteTaskLoading ? (
                                                    <div style={{ textAlign: 'center', padding: '40px' }}>
                                                        <Spinner />
                                                    </div>
                                                ) : siteTask?.getSiteTask?.response?.length > 0 ? (
                                                    siteTask.getSiteTask.response.map((task) => (
                                                        <div
                                                            key={task._id}
                                                            style={{
                                                                padding: '12px',
                                                                marginBottom: '8px',
                                                                border: '1px solid #f0f0f0',
                                                                borderRadius: '6px',
                                                                backgroundColor: selectedTasks.includes(task._id) ? '#f6ffed' : 'white'
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                                <div style={{ flex: 1 }}>
                                                                    <Checkbox
                                                                        checked={selectedTasks.includes(task._id)}
                                                                        onChange={(e) => handleTaskSelection(task._id, e.target.checked)}
                                                                    >
                                                                        <div>
                                                                            <div style={{ fontWeight: '500', marginBottom: '4px' }}>
                                                                                {task.title}
                                                                            </div>
                                                                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                                                                                {task.dutyType?.name}
                                                                            </div>
                                                                            <div style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                                                <Clock size={12} />
                                                                                {task.timeIntervalType === "duty" 
                                                                                    ? "Once per duty"
                                                                                    : task.customTimeInterval
                                                                                    ? `Every ${task.customTimeInterval} ${task.timeIntervalUnit}`
                                                                                    : task.timeSlot
                                                                                    ? `${task.timeSlot.from} - ${task.timeSlot.to}`
                                                                                    : ""
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </Checkbox>
                                                                </div>
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginLeft: '8px' }}>
                                                                    {task.anyForm && (
                                                                        <Popover content="Form attached to this task">
                                                                            <FileText size={16} style={{ color: '#1890ff' }} />
                                                                        </Popover>
                                                                    )}
                                                                    {task.attachment && (
                                                                        <Popover content="Attachments required from staff">
                                                                            <Paperclip size={16} style={{ color: '#52c41a' }} />
                                                                        </Popover>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <Empty 
                                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                        description="Select a site to view available tasks"
                                                        style={{ margin: '40px 0' }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                }
                            >
                                <Input
                                    readOnly
                                    style={{ cursor: 'pointer' }}
                                    value={`${selectedSites.length} site${selectedSites.length !== 1 ? 's' : ''} selected, ${selectedTasks.length} task${selectedTasks.length !== 1 ? 's' : ''} assigned`}
                                    suffix={<Search size={16} />}
                                    placeholder="Click to select sites and tasks"
                                    className="generic-input-control"
                                />
                            </Popover>
                            
                            {(selectedSites.length > 0 || selectedTasks.length > 0) && (
                                <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                    {selectedSites.map(site => (
                                        <Tag key={site._id} color="green" icon={<MapPin size={12} />}>
                                            {" "+site.sitename}
                                        </Tag>
                                    ))}
                                    {selectedTasks.length > 0 && (
                                        <Tag color="blue" icon={<FileText size={12} />}>
                                            {" "+selectedTasks.length} task{selectedTasks.length !== 1 ? 's' : ''}
                                        </Tag>
                                    )}
                                </div>
                            )}
                        </Form.Item>
                    </div>


                    {/* Notes */}
                    <Form.Item label="Notes" >
                        <Input.TextArea
                            rows={4}
                            placeholder="Add any additional notes or instructions..."
                            onChange={(e) => setNote(e.target.value)}
                            showCount
                            maxLength={500}
                            className="generic-input-control"
                        />
                    </Form.Item>

                    <Form.Item style={{ marginBottom: '24px' }}>
                        <label>Repeat on</label>
                        <br/>
                        <br/>
                        <Checkbox checked={days['all']} indeterminate={days['all']==false && Object.values(days).slice(1, Object.values(days)?.length)?.find((day)=>day==true)} onChange={(e)=>handelAllDays(e.target)} value={"all"}>All days</Checkbox>
                        
                        <div style={{display:'flex', gap:'10px', flexDirection:'row', marginTop:'16px', fontWeight:400, alignItems:'center'}}>
                            <Checkbox checked={days['mon']}  onChange={(e)=>setDays({...days, [e.target.value]: e.target.checked})} value={"mon"}>Mon</Checkbox>
                            <Checkbox checked={days['tue']}  onChange={(e)=>setDays({...days, [e.target.value]: e.target.checked})} value={"tue"}>Tue</Checkbox>
                            <Checkbox checked={days['wed']}  onChange={(e)=>setDays({...days, [e.target.value]: e.target.checked})} value={"wed"}>Wed</Checkbox>
                            <Checkbox checked={days['thu']}  onChange={(e)=>setDays({...days, [e.target.value]: e.target.checked})} value={"thu"}>Thu</Checkbox>
                            <Checkbox checked={days['fri']}  onChange={(e)=>setDays({...days, [e.target.value]: e.target.checked})} value={"fri"}>Fri</Checkbox>
                            <Checkbox checked={days['sat']}  onChange={(e)=>setDays({...days, [e.target.value]: e.target.checked})} value={"sat"}>Sat</Checkbox>
                            <Checkbox checked={days['sun']}  onChange={(e)=>setDays({...days, [e.target.value]: e.target.checked})} value={"sun"}>Sun</Checkbox>
                        </div>

                    </Form.Item>

                    {/* Validation Alert */}
                    {!isFormValid() && (
                        <Alert
                            message="Required Information"
                            description="Please assign the task to someone and select at least one site or task to continue."
                            type="info"
                            showIcon
                            style={{ marginTop: '32px' }}
                        />
                    )}

                </Form>
            </Drawer>
        </div>
    );
};